export enum MessagingTransferState {
	None = 0,
	Offering = 1,
	Transfered = 2,
	Fallback = 3,
}
